import { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { isMobile, RenderSection } from '.';
import { FaqData } from '../../../redux-store/types/faq';
import { FAQ_URL } from '../../../utils/constants';
import en from '../../../lang/en-us';

const { common } = en;

type LocationProps = {
    faqs: FaqData[];
};
interface FaqSectionProps extends RouteComponentProps<any, any, LocationProps> {
    getFaqs: () => Promise<FaqData>;
}

function FaqSectionView(props: FaqSectionProps) {
    const { faqs = [] } = props.history.location.state || {};
    useEffect(() => {
        if (!faqs.length) {
            props.history.push(FAQ_URL);
            return;
        }
    }, []);

    useEffect(() => {
        const onResize = () => {
            if (!isMobile(window.navigator.userAgent)) {
                props.history.replace(FAQ_URL);
                return;
            }
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <div className="curved-bg faq-curved">
            <h2 className="heading">
                <a
                    onClick={() => {
                        props.history.replace(FAQ_URL);
                    }}
                >
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {common.FAQ}
            </h2>
            <div className="faq-mobile mobile_mode">
                <div className="faq-sections">
                    <div className="faq-answers">
                        <div className="faq-list">
                            {faqs.map((faq, index) => (
                                <RenderSection key={index} {...faq} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default FaqSectionView;
